import { FC, ReactNode } from 'react';

import { Card, Text, VSpacingContainer } from '@hh.ru/magritte-ui';
import { LockClosedOutlinedSize24 } from '@hh.ru/magritte-ui/icon';

import styles from './styles.less';

interface LockedContentProps {
    title: string;
    description: string;
    action: ReactNode;
}
const LockedContent: FC<LockedContentProps> = ({ description, title, action }) => {
    return (
        <div className={styles.lockedContent}>
            <Card borderRadius={24} padding={12} showBorder stretched>
                <div className={styles.content}>
                    <span className={styles.icon}>
                        <LockClosedOutlinedSize24 />
                    </span>
                    <VSpacingContainer default={6}>
                        <div className={styles.textCenter}>
                            <Text typography="title-4-semibold">{title}</Text>
                        </div>
                        <div className={styles.textCenter}>
                            <Text typography="paragraph-3-regular" maxLines={4} style="secondary">
                                {description}
                            </Text>
                        </div>
                    </VSpacingContainer>
                    {action}
                </div>
            </Card>
        </div>
    );
};

export default LockedContent;
